<template>
    <v-container>

        <div align="center">
            <h3 class="primary--text">INSCORA COVID 19</h3>
        </div>
        <h3>Por favor leer las instrucciones antes de continuar.</h3>

        <li>1) Si es la primera vez que ingresa a la aplicación por favor llenar la Ficha de COVID 19.</li>

        <v-card
                color="#F2CECE"
                class="mx-auto"
                max-width="500"
        >
            <v-img
                    src="https://previews.123rf.com/images/vladwel/vladwel1809/vladwel180900017/110263158-patient-card-icon-or-medical-form-list-with-results-data-and-approved-check-mark-vector-symbol-flat-.jpg"
                    height="150px"
            ></v-img>
            <v-card-title>
                <p class="font-weight-bold">Ficha de COVID 19</p>
                <p>La ficha inicial permite un primer acercamiento con el paciente para el seguimiento de COVID 19, el llenado de este formulario debe ser una sola vez a menos que se solicite actualizarlo.</p>

            </v-card-title>
            <v-card-actions>
                <v-btn
                        color="primary"
                        text
                        @click="goToFicha"
                >
                    Ingresar Ficha
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
        <br>
        <br>

        <li>2) Si ya tiene una ficha inicial creada por favor continuar con el centro de alarmas.</li>
        <v-card
                color="#F2CECE"
                class="mx-auto"
                max-width="500"
        >
            <v-img
                    src="https://img.huffingtonpost.com/asset/5e6ba6602300002b1ade4511.jpeg?ops=scalefit_630_noupscale"
                    height="150px"
            ></v-img>

            <v-card-title>
                <p class="font-weight-bold">Centro de Alarmas</p>
                <div style="text-align : justify;">
                    El centro de alarmas se encuentra disponible entre las 00:00 a 20:00 horas , el llenado de la misma le permite acudir e ingresar a su trabajo de manera normal y segura. El llenado del formulario debe ser diario.
                </div>
            </v-card-title>
            <v-card-actions>
                <v-btn
                        color="primary"
                        text
                        @click="gotToAlarm"
                >
                    Ingresar Centro Alarma
                </v-btn>

                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-container>
</template>
<script>

    export default {
        data() {
            return {
            };
        },
        methods: {
            goToFicha(){
                this.$router.push({ name: 'covidRegister'});
            },
            gotToAlarm(){
                this.$router.push({ name: 'covidAlarmRegister'});
            }

        },
        computed: {},
        created() {



        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/covid/CovidIndex.vue